import { render, staticRenderFns } from "./ModalThemThongTinTaiKhoan.vue?vue&type=template&id=0a54c3f5&scoped=true&"
import script from "./ModalThemThongTinTaiKhoan.vue?vue&type=script&lang=js&"
export * from "./ModalThemThongTinTaiKhoan.vue?vue&type=script&lang=js&"
import style0 from "./ModalThemThongTinTaiKhoan.vue?vue&type=style&index=0&id=0a54c3f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54c3f5",
  null
  
)

export default component.exports